// extracted by mini-css-extract-plugin
export default {"switcher":"PeriodSwitcher_switcher__OsPdw"};